import * as React from 'react';
import { connect } from 'react-redux';
import { EDomain } from '../../base/types';
import { Selectors as ExercisesSelectors } from '../../exercises';
import { IState } from '../../store/state';
import { IExercise } from '../types';
import HighscoreCardContainer from './HighscoreCardContainer';

interface IOwnProps {
  domain?: EDomain;
  numberOfColumns?: number;
  userId?: number;
}

export interface IHighscoresProps extends IOwnProps {
  exercises: IExercise[];
}

const DomainHighscoresFC: React.FC<IHighscoresProps> = ({ exercises, numberOfColumns = 2, userId }) => {
  const columnClass = `col-${Math.floor(12 / numberOfColumns)}`;
  return (
    <>
      {exercises.map((exercise) => (
        <HighscoreCardContainer
          key={exercise.exerciseId}
          exerciseId={exercise.exerciseId}
          siblings={exercise.siblings}
          locked={exercise.locked}
          className={columnClass}
          userId={userId}
        />
      ))}
    </>
  );
};

export const mapStateToProps = (state: IState, props: IOwnProps) => {
  const { domain, userId } = props;
  let exercises: IExercise[] = [];
  if (typeof domain !== 'undefined') {
    exercises = ExercisesSelectors.getDomainExercises(state, domain, userId);
  }
  return {
    exercises,
  };
};

const DomainHighscores = connect(mapStateToProps)(DomainHighscoresFC);
export default DomainHighscores;
